<template>
	<footer v-if="!['login', 'checkout', 'invoice', 'order-confirmation', 'birth-kit-order-form'].some((p) => $route.path.includes(p))">
		<div class="bg-gradient-to-b from-ihh-pink to-ihh-purple h-full px-5 py-14 flex w-full justify-center text-ihh-midnight-gray">
			<div class="w-full max-w-7xl">
				<div class="flex w-full justify-center text-xl md:text-4xl font-semibold tracking-widest text-ihh-midnight-gray">Join our newsletter</div>

				<div class="w-full justify-center gap-x-4 gap-y-4 mt-6 grid grid-cols-1 md:flex">
					<div class="relative w-full md:max-w-lg">
						<input
							type="text"
							id="name"
							v-model="yourEmail"
							required
							class="py-3 pl-12 flex border border-slate-100 rounded-lg w-full text-sm md:text-base bg-white font-light text-black placeholder-ihh-gray shadow-md relative"
							placeholder="Your email address"
						/>
						<div class="absolute left-4 top-1/2 transform -translate-y-1/2">
							<img src="https://cfl-mango.s3.amazonaws.com/uploads/downloads/ob-envelope.svg" class="w-5" />
						</div>
					</div>
					<button
						@click="subscribe"
						class="text-sm md:text-base text-ihh-midnight-gray py-3 px-10 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon delay-100 transition active:scale-90 tracking-wide"
					>
						Join
					</button>
				</div>

				<!-- <div class="flex my-16 grid grid-cols-1 md:flex"> -->
				<div class="w-full justify-around mb-12 mt-16 grid grid-cols-1 lg:flex">
					<div class="flex justify-center xl:justify-start order-2 lg:order-1 mt-8 sm:mt-0 px-8">
						<div class="flex-col">
							<div class="flex w-full max-w-52 justify-center">
								<a href="/">
									<FooterLogo />
								</a>
							</div>
							<div class="text-[15px] mt-4">
								Need Help?
								<router-link to="/help-center" class="text-ihh-dark-salmon underline">Contact us here</router-link>
							</div>
						</div>
					</div>

					<div class="flex w-full justify-center order-1 md:order-2 flex-col flex-grow text-sm mb-16 md:mb-0 md:mt-16 lg:mt-0">
						<div class="flex flex-wrap lg:flex-no-wrap sm:justify-center lg:justify-around w-full text-sm md:text-base tracking-wide gap-x-2">
							<div v-for="footer in footerLinks" :key="footer.title" class="flex flex-col text-ihh-midnight-gray mb-6 leading-8 px-6">
								<div class="flex w-full text-start font-bold mb-2 text-lg">
									{{ footer.title }}
								</div>
								<ul class="w-full">
									<li class="break-words whitespace-normal w-full" v-for="detail in footer.details" :key="detail.name">
										<a class="hover:underline" :href="detail.path">
											{{ detail.name }}
										</a>
									</li>
								</ul>
							</div>

							<div class="lg:hidden">
								<div class="flex text-start font-bold mb-2 ml-4 text-lg flex-wrap">Follow Us</div>
								<div class="flex gap-2 px-4 w-48">
									<a href="https://www.instagram.com/inhishandsbirth/?hl=en" target="_blank" class="w-9 shrink-0">
										<img src="/images/ihh-instagram0129.svg" class="aspect-square bg-white p-[7px] rounded-lg shadow-lg w-full" />
									</a>
									<a href="https://www.facebook.com/InHisHandsBirthSupply" target="_blank" class="w-9 shrink-0">
										<img src="/images/ihh-facebook0129.svg" class="aspect-square bg-white py-[7px] px-[10px] rounded-lg shadow-lg w-full" />
									</a>
									<a href="https://www.pinterest.com/inhishandsbirth/" target="_blank" class="w-9 shrink-0">
										<img src="/images/ihh-pinterest0129.svg" class="aspect-square bg-white py-[7px] px-[7px] rounded-lg shadow-lg w-full" />
									</a>
									<a href="https://x.com/inhishandsbirth" target="_blank" class="w-9 shrink-0">
										<img src="/images/x.svg" class="aspect-square bg-white p-[7px] rounded-lg shadow-lg w-full" />
									</a>
								</div>
							</div>
						</div>
					</div>

					<div class="order-3 hidden lg:block">
						<div class="flex text-start font-bold mb-2 ml-4 text-lg flex-wrap">Follow Us</div>
						<div class="flex gap-2 px-4 w-48">
							<a href="https://www.instagram.com/inhishandsbirth/?hl=en" target="_blank" class="w-9 shrink-0">
								<img src="/images/ihh-instagram0129.svg" class="aspect-square bg-white p-[7px] rounded-lg shadow-lg w-full" />
							</a>
							<a href="https://www.facebook.com/InHisHandsBirthSupply" target="_blank" class="w-9 shrink-0">
								<img src="/images/ihh-facebook0129.svg" class="aspect-square bg-white py-[7px] px-[10px] rounded-lg shadow-lg w-full" />
							</a>
							<a href="https://www.pinterest.com/inhishandsbirth/" target="_blank" class="w-9 shrink-0">
								<img src="/images/ihh-pinterest0129.svg" class="aspect-square bg-white py-[7px] px-[7px] rounded-lg shadow-lg w-full" />
							</a>
							<a href="https://x.com/inhishandsbirth" target="_blank" class="w-9 shrink-0">
								<img src="/images/x.svg" class="aspect-square bg-white p-[7px] rounded-lg shadow-lg w-full" />
							</a>
						</div>
					</div>
				</div>

				<div class="flex w-full justify-center items-center flex-col lg:flex-row">
					<div class="w-full justify-center text-center lg:justify-around order-1">
						<div class="text-xs mb-2 lg:mb-0">
							Copyright © {{ currentYear }},
							<span class="font-bold">In His Hands Birth Supply.</span>
						</div>
					</div>

					<div class="flex w-full justify-around order-3 lg:order-2 mt-10 lg:mt-0">
						<div class="flex w-full max-w-lg justify-around">
							<div style="background-image: url(/images/google-pay.png)" class="w-16 bg-contain bg-center bg-no-repeat mx-2" />
							<img src="/images/ob-visa0129.svg" class="w-12 h-12" />
							<img src="/images/ob-mastercard0129.svg" class="w-12 h-12" />
							<img src="/images/ob-amex0129.svg" class="w-12 h-12" />
							<img src="/images/ob-paypal0129.svg" class="w-12 h-12" />
							<div style="background-image: url(/images/apple-pay.png)" class="w-16 bg-contain bg-center bg-no-repeat mx-2" />
						</div>
					</div>

					<div class="flex w-full justify-around text-center order-2 lg:order-3">
						<div class="text-xs">
							Developed by
							<span class="font-bold">Happy Path Software</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import FooterLogo from '../partials/footer-logo.vue'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
	components: { FooterLogo },
	inject: ['store'],
	data() {
		return {
			yourEmail: '',
			footerLinks: [
				{
					title: 'Shop',
					details: [
						{ name: `Birth Kits`, path: `/categories/birth-kits` },
						{ name: `Birth Supplies`, path: `/categories/birth-supplies` },
						{ name: `Water Birth`, path: `/categories/water-birth` },
						{ name: `Build Your Own Water Birth Package`, path: `/build-your-own-water-birth-package` },
						{ name: `Natural`, path: `/categories/herbal-natural` },
						{ name: `For Midwives`, path: `/categories/midwifery-supplies` },
						{ name: `For Mothers`, path: `/categories/mom-baby` },
						{ name: `Help with...`, path: `/categories/help-with` },
						{ name: `Brands`, path: `/categories/brands` },
					],
				},
				{
					// title: 'Brands',
					title: 'About',
					details: [
						{ name: `About Us`, path: `/about-us` },
						{
							name: `Custom Birth Kit Service`,
							path: `/new-birth-kit-setup`,
						},
						{
							name: 'Frequently Asked Questions',
							path: '/faqs',
						},
						//   { name: `Wishgarden Herbs`, path: `/water-birth123` },
						//   { name: `Oasis`, path: `/water-birth123` },
						//   { name: `Ethicon`, path: `/water-birth123` },
						//   { name: `Earth Mama`, path: `/water-birth123` },
						//   { name: `Earthley Wellness`, path: `/water-birth123` },
						//   { name: `Germaine Labs`, path: `/water-birth123` },
						//   { name: `Birth Pool in a Box`, path: `/water-birth123` },
						//   { name: `Masimo`, path: `/water-birth123` },
						//   { name: `Arjo Huntleigh`, path: `/water-birth123` },
					],
				},
				{
					title: 'Support',
					details: [
						{ name: `Help Center`, path: `/help-center` },
						{ name: `Returns`, path: `/returns` },
						{ name: `Final Sale Items`, path: `/final-sale-items` },
						{
							name: `Ordering & Shipping Info`,
							path: `/shipping-info`,
						},
						{
							name: `Discount Code Terms`,
							path: `/discount-code-terms`,
						},
						{
							name: `Gift Certificates`,
							path: `/gift-certificates`,
						},
						//   { name: `Custom Birth Kit Service`, path: `/water-birth123` },
						//   { name: `About Us`, path: `/water-birth123` },
						{ name: `Sitemap`, path: `/sitemap` },
					],
				},
			],
		}
	},

	methods: {
		async subscribe() {
			console.log('subscribing with email: ', this.yourEmail)

			try {
				const response = await axios.post(`${this.store.api}/controllers/sendlane/newsletter`, { email: this.yourEmail })

				if (response?.data?.message === 'Successfully handled request') {
					Swal.fire({
						icon: 'success',
						title: 'Subscribed!',
						text: `Thank you for subscribing to our newsletter`,
						confirmButtonColor: '#e59789',
					})
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Error Subscribing',
						text: `Please try again later.`,
					})
				}
			} catch (error) {
				console.log('error subscribing: ', error)

				Swal.fire({
					icon: 'error',
					title: 'Error Subscribing',
					text: `Please try again later.`,
				})
			}
		},
	},

	computed: {
		currentYear() {
			return new Date().getFullYear()
		},
	},
}
</script>

<style></style>
